import {calculateROI, Config, StepEvaluation, StepEvaluationWithVillage, StepWithExplanation} from "../../Calculator/ResourceUpgradeOrder";
import React, {ReactNode} from "react";
import {useTranslationContext} from "../../../react/providers/TranslationContext";
import {Modal} from "../../../react/components/ui/spectre/Modal";
import {ModalBody, OverflowHandling} from "../../../react/components/ui/spectre/ModalBody";
import {Step} from "./Step";

type Props = {
    config: Config,
    step: StepEvaluationWithVillage,
    explain: Array<StepWithExplanation>,
    onClose: () => void,
};

export function DetailModal({config, step, explain, onClose}: Props): ReactNode {
    const {getTranslator} = useTranslationContext();
    const translate = getTranslator('tool/trav/ResourceUpgradeOrder');
    const roi = calculateROI(config, [step]);

    return <Modal onClose={onClose}>
        <ModalBody overflowHandling={OverflowHandling.Auto}>
            <div className='stepDetailModal'>
                <div>{translate('modalBestOption')}</div>
                <div>{<Step village={config.initialVillageState} step={step.step.step} />}</div>

                {step.step.preSteps.length > 0 && <div className='mt-2'>
                    <div>{translate('modalPreStepsIncluded')}</div>
                    <ul className='my-0 p-0'>
                        {step.step.preSteps.map(preStep =>
                            <li className='m-0 p-0'><Step village={config.initialVillageState} step={preStep} /></li>)}
                    </ul>
                </div>}

                {roi &&
                    <div className='mt-2 roiTable'>
                        <div>{translate('modalInfoTotalCostSum')}</div>
                        <div>{roi.totalCostSum}</div>

                        <div>{translate('modalInfoProductionDelta')}</div>
                        <div>{roi.productionDelta}</div>

                        <div>{translate('modalInfoROI')}</div>
                        <div>{Math.round(roi.roi)}</div>
                    </div>
                }

                <hr/>

                <div>{translate('modalEvaluatedOptions')}</div>

                <div className='stepList mt-2'>
                    <div className='text-bold'>{translate('modalStepListStep')}</div>
                    <div className='text-bold'>{translate('modalStepListScore')}</div>

                    {
                        explain
                            .sort((a, b) => b.efficiency - a.efficiency)
                            .map((stepData, stepIndex) => {
                                return <React.Fragment key={stepIndex}>
                                    <div><Step village={config.initialVillageState} step={stepData.step.step} /></div>
                                    <div>{Math.floor(stepData.efficiency * 1000)}</div>
                                </React.Fragment>
                            })
                    }
                </div>
            </div>
        </ModalBody>
    </Modal>
}
